import { Link } from 'react-router';

import { useAuthStore } from '@/stores/authStore';

import { USER_ROLES } from '@/constants/global-constants';
import {
  adminRoutes,
  controllerRoutes,
  executorRoutes,
} from '@/constants/route-settings';

export const NoMatchPage = () => {
  const { user } = useAuthStore.getState();
  const linkTo = () => {
    switch (user?.role) {
      case USER_ROLES.ADMIN.value:
        return adminRoutes.users;
      case USER_ROLES.EXECUTOR.value:
        return executorRoutes.myDocuments;
      case USER_ROLES.CONTROLLER.value:
        return controllerRoutes.myDocuments;
      default:
        return '/';
    }
  };

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-slate-900 p-4">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Stars */}
        <div className="absolute left-1/4 top-1/4 h-2 w-2 animate-star-pulse rounded-full bg-white" />
        <div className="absolute left-3/4 top-1/2 h-2 w-2 animate-twinkle rounded-full bg-white delay-300" />
        <div className="absolute left-1/2 top-3/4 h-2 w-2 animate-star-pulse rounded-full bg-white delay-700" />
        <div className="absolute left-2/3 top-1/3 h-1.5 w-1.5 animate-twinkle rounded-full bg-white delay-500" />
        <div className="absolute left-1/3 top-2/3 h-1.5 w-1.5 animate-star-pulse rounded-full bg-white delay-200" />

        {/* Flying UFOs */}
        <div className="absolute -top-8 animate-chaotic-1">
          <span className="text-4xl">🛸</span>
        </div>
        <div className="absolute -top-16 animate-chaotic-2 delay-1000">
          <span className="rotate-180 text-4xl">🚀</span>
        </div>

        {/* Shooting Stars */}
        <div className="absolute h-px w-32 rotate-45 animate-comet bg-blue-400 blur-[1px]" />
        <div className="delay-[2000ms] absolute h-px w-32 rotate-45 animate-comet bg-blue-400 blur-[1px]" />
        <div className="delay-[4000ms] absolute h-px w-32 rotate-45 animate-comet bg-blue-400 blur-[1px]" />
      </div>

      {/* Main content */}
      <div className="relative z-10 rounded-2xl p-8 text-center">
        <h1 className="mb-4 text-9xl font-bold text-blue-500 drop-shadow-[0_0_15px_rgba(37,99,235,0.5)]">
          404
        </h1>
        <div className="relative">
          <h2 className="mb-6 text-4xl font-bold text-yellow-400 drop-shadow-[0_0_10px_rgba(250,204,21,0.5)]">
            Ой-ой! Здається, ми заблукали у космосі!
          </h2>
        </div>

        <div className="mb-8 space-y-4">
          <p className="text-xl text-blue-200">
            Сторінка, яку ви шукаєте, десь мандрує у кіберпросторі 🚀
          </p>
          <p className="text-lg text-blue-300">
            Використовуйте стрілки для керування кораблем! ✨
          </p>
        </div>

        <Link
          to={linkTo()}
          className="inline-block transform rounded-full bg-blue-600 px-8 py-3 text-lg 
            font-semibold text-white shadow-sm transition-all duration-300 
            hover:rotate-2 hover:scale-105 hover:bg-blue-700 hover:shadow-[0_0_15px_rgba(37,99,235,0.5)]"
        >
          <span className="inline-block">🛸</span> Повернутися на Землю
        </Link>
      </div>
    </div>
  );
};
